import { Row, Table } from "antd";
import { useMemo } from "react";
import { useGetAccountsTableColumns } from "./hooks/getAccountsTableColumns";
import { useLoadData } from "./hooks/loadData";
import { Header } from "./components/Header";
import { useNoCountPaginationProps } from "../../../../../../lib/hooks/useNoCountPaginationProps";

type PortalAccessProps = {
  customerId: string;
};

export const Accounts = ({ customerId }: PortalAccessProps) => {
  const { columns } = useGetAccountsTableColumns();

  const { data, total, isLoading } = useLoadData(customerId);

  const scroll = useMemo(() => {
    return data.length > 5 ? { y: 185 } : undefined;
  }, [data]);

  const { paginationProps } = useNoCountPaginationProps(total);

  return (
    <Row className="justify-space-between align-center">
      <Header customerId={customerId} />
      <Row className="mt-6">
        <Table
          dataSource={data}
          columns={columns}
          loading={isLoading}
          pagination={paginationProps}
          className="overflow-y-auto small-table"
          rowKey="i"
          sticky
          scroll={scroll}
        />
      </Row>
    </Row>
  );
};
